import React from "react";
import { StatsWrapper } from "./style";
import PropTypes from "prop-types";

const Stats = (props) => {
	const { stats } = props;

	return (
		<StatsWrapper>
			{stats.map((stat, index) => (
				<div key={index} className="statsBlock">
					<div className="statsHeading">{stat.name}</div>
					<div className="statsContent">{stat.detail}</div>
				</div>
			))}
		</StatsWrapper>
	);
};

Stats.propTypes = {
	stats: PropTypes.array,
};

Stats.defaultProps = {
	stats: [],
};

export default Stats;
